import React from 'react';
import SelectIndex from '../../form/selec-address/index';
import { getDistricts } from './data';
import model from '../../assets/model';

class District extends React.Component {
    state = {
        options: []
    }

    componentDidUpdate(prevProps) {
        // 当城市改变时，获取对应的区县列表
        const { cityId, cascade_parent_api_name, countryId, provinceId,parent_node } = this.props;
        // 当省份改变时，获取对应的城市列表
        if (cityId && cascade_parent_api_name && cityId[cascade_parent_api_name] && ((prevProps.cityId == null && cityId[cascade_parent_api_name]) || cityId[cascade_parent_api_name] !== prevProps.cityId[cascade_parent_api_name])) {
            getDistricts({ parentPath: countryId[parent_node.parent_node.cascade_parent_api_name] + '/' + provinceId[parent_node.cascade_parent_api_name] + '/' + cityId[cascade_parent_api_name], cardId: model.cardId }, (data) => {
                this.setState({ options: data.optionList });
            });
        }
        //国家或者省更改，区的下拉数据要清空
        if(countryId &&  prevProps.countryId && countryId[parent_node.parent_node.cascade_parent_api_name] && prevProps.countryId[parent_node.parent_node.cascade_parent_api_name] && countryId[parent_node.parent_node.cascade_parent_api_name] != prevProps.countryId[parent_node.parent_node.cascade_parent_api_name] ){
            this.setState({ options: [] });
        }
        if(provinceId &&  prevProps.provinceId && provinceId[parent_node.cascade_parent_api_name] && prevProps.provinceId[parent_node.cascade_parent_api_name] && provinceId[parent_node.cascade_parent_api_name] != prevProps.provinceId[parent_node.cascade_parent_api_name] ){
            this.setState({ options: [] });
        }
    }
    componentDidMount() {
        //当有默认值时，需要获取市数据
        let { parent_node } = this.props
        if(parent_node && parent_node.default_value){
            getDistricts({ parentPath: parent_node.parent_node.parent_node.default_value + '/' + parent_node.parent_node.default_value + '/' + parent_node.default_value, cardId: model.cardId }, (data) => {
                this.setState({ options: data.optionList });
            });
        }
    }
    render() {
        return (
            <SelectIndex 
                {...this.props} 
                options={this.state.options}
                disabled={!this.props.cityId}
                onChange={this.props.onDistrictChange}
            />
        );
    }
}

export default District;


// WEBPACK FOOTER //
// ./src/component/Address/District.js